import { Component, ViewEncapsulation } from '@angular/core';
import { IBreadcrumbData } from '../../../../interfaces/breadcrumb-data.interface';
import { ConfigService } from '../../../../services/config.service';
import { NotificationService } from '../../../../services/notification.service';
import { WebSocketService } from '../../../../services/web-socket.service';

// tslint:disable-next-line:class-name
interface kioskStates {
  class: string;
  lane: string;
}

@Component({
  selector: 'app-lane-control',
  templateUrl: './lane-control.component.html',
  styleUrls: ['./lane-control.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class LaneControlComponent {
  public lanes: any = [];
  public isError = false;
  public kioskState = [];
  public printersErrorState = [];
  public printerErrorStatus = '';
  public ocrServiceActive = false;

  /**
   * BreadcrumbData
   */
  breadcrumbData: IBreadcrumbData;

  constructor(private config: ConfigService, private snackBar: NotificationService, public wsService: WebSocketService) {
    setTimeout(() => {
      this.getLanes();
    }, 500);

    this.breadcrumbData = {
      titles: {
        icon: 'commute',
        links: [
          {
            text: 'Lane Control',
          },
        ],
      },
      description: '',
      buttons: [
        {
          text: 'Reinicio',
          action: () => this.restart(),
          icon: 'restore',
          disabled: false
        },
      ],
    };

    this.setOcrServerActive();
  }

  getLanes() {
    if (this.config.getConfigError()) {
      this.snackBar.showError('No se ha podido cargar la configuración');
      return;
    }
    this.lanes = this.config.getLanes();
  }
  getkioskState(laneid: any) {
    if (this.kioskState[laneid] == null) {
      return;
    }
    return this.kioskState[laneid];
  }

  updateKioskChange(event: kioskStates) {
    this.kioskState[event.lane] = event.class;
    console.log(`updateKioskChange: ${JSON.stringify(this.kioskState)}`);
  }

  updateConfig(event: any) {
    console.log(`Esta es la configuración L-${event.laneId}:  ${JSON.stringify(event.laneConfig)}`);
    this.config.setLane(event.laneId, event.laneConfig);
  }

  setPrinterErrorStatus(laneId: number, status: string) {
    // console.log('printerErrorStatus lane-control ' + status);
    this.printersErrorState[laneId] = status;
  }

  setOcrServerActive(){
    this.ocrServiceActive = this.config.config.ocr_servers.length > 0 ? true: false;
  }

  restart() {
    console.log('restart');
    const data = [];
    if (this.config?.config?.com_server?.pm2ServiceName && this.config.config.com_server.IP) {
      let payload = { server: this.config?.config?.com_server?.pm2ServiceName, host: this.config.config.com_server.IP, type: 'pm2' };
      data.push(payload);
    }
    if (this.config?.config?.server?.pm2ServiceName && this.config.config.server.IP) {
      let payload = { server: this.config?.config?.server?.pm2ServiceName, host: this.config.config.server.IP, type: 'pm2' };
      data.push(payload);
    }
    if (this.config?.config?.auth_server?.pm2ServiceName && this.config.config.auth_server.IP) {
      let payload = { server: this.config?.config?.auth_server?.pm2ServiceName, host: this.config.config.auth_server.IP, type: 'pm2' };
      data.push(payload);
    }

    if (this.config?.config?.ocr_servers) {
      this.config?.config?.ocr_servers.map(function (ocr_server) {
        if (ocr_server.windowsServiceName && ocr_server.IP) {
          let payload = { server: ocr_server.windowsServiceName, host: ocr_server.IP, type: 'windows' };
          data.push(payload);
        }
      });
    }

    this.wsService.send('restartAll', data);
    console.log(`restarting all...`);
  }
}
